const BASE_ROUTE = "/my-meds";

export const MY_MEDS_ROUTE = {
  BASE: BASE_ROUTE,
  REFILL_REQUEST: `${BASE_ROUTE}/refill-request/:productId?`,
} as const;
